<template>
  <v-dialog
    :model-value="modelValue"
    max-width="480"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card rounded="lg" class="pa-2">
      <v-card-text class="pt-6 pb-3">
        <div class="d-flex align-start gap-4">
          <!-- Blue circle with checkmark -->
          <div
            class="d-flex align-center justify-center rounded-circle flex-shrink-0"
            style="width: 48px; height: 48px; background-color: #e3f2fd"
          >
            <v-icon color="blue-darken-2" size="26">mdi-check-circle</v-icon>
          </div>

          <div class="flex-grow-1">
            <div class="text-h6 font-weight-bold mb-1">Update Matter Stage?</div>
            <p class="text-body-2 text-grey-darken-1 mb-4">
              Your settlement statement is ready. Would you like to update the matter stage?
            </p>

            <!-- Stage transition row -->
            <div
              class="d-flex align-center flex-wrap gap-2 pa-3 rounded mb-3"
              style="background: #f5f5f5"
            >
              <span class="text-body-2 text-grey-darken-2">Current stage:</span>
              <span class="text-body-2 font-weight-medium">{{ currentStage }}</span>
              <v-icon size="16" color="grey-darken-1">mdi-arrow-right</v-icon>
              <span class="text-body-2 font-weight-bold" style="color: #1565c0">Settlement Pending</span>
            </div>

            <p class="text-caption text-grey-darken-1">
              This updates the matter stage in LeanLaw. You can always change it later from the matter settings.
            </p>
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="px-6 pb-5 justify-end gap-2">
        <LlSecondaryButton variant="outlined" @click="$emit('not-now')">Not Now</LlSecondaryButton>
        <LlSecondaryButton color="primary" variant="elevated" @click="$emit('update-stage')">
          Yes, Update Stage
        </LlSecondaryButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';

defineProps({
  modelValue: { type: Boolean, default: false },
  currentStage: { type: String, default: 'Active' },
});

defineEmits(['update:modelValue', 'not-now', 'update-stage']);
</script>
